import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { SEARCH_PERSIST_KEY } from '../persistedKeys';
import { createSearchActions } from './search.actions';
import { migrateSearchPersistedState, SEARCH_STORE_VERSION } from './search.migrations';
import { searchInitialState, SearchStore } from './search.types';

/**
 * Search Store
 *
 * Manages recent searches (users, tags and queries) with persistence to localStorage.
 * Recent searches are limited to MAX_RECENT_SEARCHES per type.
 */
export const useSearchStore = create<SearchStore>()(
  devtools(
    persist(
      (set) => ({
        ...searchInitialState,
        ...createSearchActions(set),
      }),
      {
        name: SEARCH_PERSIST_KEY,
        version: SEARCH_STORE_VERSION,
        migrate: migrateSearchPersistedState,
        // Recent searches persist; active tags are URL-derived and reach is session-only.
        partialize: (state) => ({
          recentUsers: state.recentUsers,
          recentTags: state.recentTags,
          recentQueries: state.recentQueries,
        }),
      },
    ),
    {
      name: 'search-store',
      enabled: process.env.NODE_ENV === 'development',
    },
  ),
);
